import * as React from 'react';

import { cn } from '@/lib/utils';

type RadioProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'>;

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ className, checked, disabled, ...props }, ref) => {
    return (
      <span
        className={cn(
          'relative inline-flex h-4 w-4 shrink-0 items-center justify-center',
          className,
        )}
      >
        <input
          ref={ref}
          type="radio"
          checked={checked}
          disabled={disabled}
          className="sr-only"
          {...props}
        />
        <span
          aria-hidden
          className={cn(
            'flex h-4 w-4 items-center justify-center rounded-full border bg-white shadow-sm border-border',
            //checked ? 'border-primary' : 'border-border',
            disabled ? 'opacity-50' : null,
          )}
        >
          {checked ? <span className="h-2 w-2 rounded-full bg-primary" /> : null}
        </span>
      </span>
    );
  },
);
Radio.displayName = 'Radio';
